import { Logger } from 'DVWebNodeUtils'
import { createSelector } from './selectorWrapper'
import { IDetailPageState } from '../reducers'
import { StringIdToString } from '../reducers/strings'
import { StringId } from '../components/localizer/stringId'
import { getAllDefaultStrings } from '../components/localizer/localizer'
import { getStringFromId } from '../utils/stringUtils'

export type IStringMap = Partial<Record<StringId, string>>
export type IReplaceObj = { [key: string]: string }

const getStringClosure = (strings: IStringMap, logger: Logger) => (
  stringId: StringId,
  replace?: IReplaceObj
) => getStringFromId({ strings, stringId, replace, logger })
export type IGetString = ReturnType<typeof getStringClosure>

export const stringsSelector = (state: IDetailPageState) => state.strings
export const getStringsSelector = createSelector(
  stringsSelector,
  (stringsStore: StringIdToString) => {
    const translatedStringIds = Object.keys(stringsStore)
    const translations = translatedStringIds.reduce(
      (translated: Partial<Record<StringId, string>>, key: string) => {
        const stringId: StringId = StringId[key as keyof typeof StringId]
        translated[stringId] = stringsStore[key]
        return translated
      },
      {} as Partial<Record<StringId, string>>
    )
    return Object.assign({}, getAllDefaultStrings(), translations)
  }
)

// Aim of this function is to return a new getString function
// only if getStringSelector returns a new result
export const memoizedGetString = (() => {
  let previousStrings: Record<StringId, string>
  let getString: IGetString
  return (state: IDetailPageState, logger: Logger) => {
    const selectorResult = getStringsSelector(state)
    if (selectorResult !== previousStrings) {
      previousStrings = selectorResult
      getString = getStringClosure(previousStrings, logger)
    }
    return getString
  }
})()
